import { createContext, useState } from 'react';
const CardsStateContext = createContext();
const CardsContextProvider = ({ children }) => {
    //il cambio di stato di refresh attiva il refresh dei dati delle carte nei componente manage cards
    const [refresh, setRefresh] = useState(false)
      const CardsState = {
        refresh, setRefresh
    };
    return (
        <CardsStateContext.Provider value={CardsState}>
        {children}
        </CardsStateContext.Provider>
    );
};
export { CardsStateContext, CardsContextProvider };
